import React from 'react';
import { Trophy, Target, Star, Award, Users, Calendar } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const LeagueShowcase = ({ leagues }) => {
  const icons = {
    Trophy,
    Target,
    Star,
    Award
  };

  const typeColors = {
    'Regional League': 'from-blue-500 to-blue-600',
    'National Pathway': 'from-green-500 to-green-600',
    'Franchise': 'from-orange-500 to-orange-600',
    'Professional Pathway': 'from-purple-500 to-purple-600'
  };

  return (
    <div className="grid md:grid-cols-2 gap-6">
      {leagues.map((league, index) => {
        const Icon = icons[league.icon];
        const colorClass = typeColors[league.type];
        
        return (
          <Card 
            key={league.id} 
            className="group border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
          >
            {/* Color Strip */}
            <div className={`h-2 bg-gradient-to-r ${colorClass}`} />
            
            <CardContent className="p-6">
              <div className="flex items-start space-x-4 mb-4">
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center bg-gradient-to-br ${colorClass} flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <div className="flex-1">
                  <div className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-2 bg-gradient-to-r ${colorClass} text-white`}>
                    {league.type}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                    {league.name}
                  </h3>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                {league.description}
              </p>

              {/* Age Groups */}
              <div className="flex items-center space-x-2 pt-4 border-t border-gray-200">
                <Users className="w-4 h-4 text-gray-500" />
                <span className="text-sm text-gray-600 font-medium">Age Groups:</span>
                <div className="flex flex-wrap gap-2">
                  {league.ageGroups.map((age, idx) => (
                    <span 
                      key={idx}
                      className="px-2 py-1 bg-gradient-to-br from-gray-50 to-green-50 border border-green-200 rounded text-xs font-semibold text-gray-700"
                    >
                      {age}
                    </span>
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default LeagueShowcase;
